module.exports = __webpack_public_path__ + "img/begin_chat.9baa5233.png";